import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {CardActionIcons as RmwcCardActionIcons} from '@rmwc/card'
import '@rmwc/card/styles'
import '@rmwc/icon-button/styles'

const StyledRmwcCardActionIcons = styled(RmwcCardActionIcons)`
  &&& {
    flex-grow: 0;
  }
  margin-left: 16px;
`

const CardActionIcons = ({children, ...otherProps}) => <StyledRmwcCardActionIcons {...otherProps}>{children}</StyledRmwcCardActionIcons>

CardActionIcons.propTypes = {
  children: PropTypes.any
}

export {CardActionIcons}
